export const jobJourneysQueryKeyPrefix = (jobId: number) => ['job-journeys', jobId];

export const jobJourneysQueryKey = (jobId: number, search: string) => [
  ...jobJourneysQueryKeyPrefix(jobId),
  search,
];
